import React from 'react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { SlidersHorizontal, ArrowUpDown, Plane, X } from 'lucide-react';

export default function FilterSort({ sortBy, setSortBy, stopsFilter, setStopsFilter, airlineFilter, setAirlineFilter, uniqueAirlines, onReset, disableAirlines = false }) {
  // `flex-1` on mobile splits the row evenly across all four buttons so
  // they always fit the viewport (the old fixed-width pills overflowed
  // and clipped "Reset" off-screen at 375px); `md:flex-initial` restores
  // the compact right-aligned pills on desktop.
  const buttonStyle = "flex-1 md:flex-initial justify-center bg-white/5 hover:bg-white/10 text-gray-300 hover:text-white border-transparent rounded-full h-8 px-2 md:px-4 text-xs flex items-center gap-1.5 transition-all";

  return (
    <div className="flex w-full md:w-auto flex-nowrap items-center gap-1.5 md:gap-2">
      {/* Explicit type="button" throughout — this component now renders
          inside the search <form> on desktop, and the HTML default of
          type="submit" would re-fire the search on every filter click. */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="ghost" className={buttonStyle}>
            <ArrowUpDown className="w-3 h-3" />
            <span>Sort</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-light border-white/10 text-white">
          <DropdownMenuItem onSelect={() => setSortBy('best')}>Best flights</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setSortBy('price')}>Price</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setSortBy('duration')}>Duration</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setSortBy('departure')}>Departure</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="ghost" className={buttonStyle}>
            <Plane className="w-3 h-3" />
            <span>Stops</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-light border-white/10 text-white">
          <DropdownMenuItem onSelect={() => setStopsFilter('any')}>Any</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setStopsFilter('0')}>Nonstop</DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setStopsFilter('1')}>1 Stop</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="ghost" className={`${buttonStyle} ${disableAirlines ? 'opacity-60 cursor-not-allowed' : ''}`} disabled={disableAirlines}>
            <SlidersHorizontal className="w-3 h-3" />
            <span>Airlines</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="glass-light border-white/10 text-white">
          <DropdownMenuItem onSelect={() => setAirlineFilter('all')}>All Airlines</DropdownMenuItem>
          {uniqueAirlines.map(airline => (
            <DropdownMenuItem key={airline} onSelect={() => setAirlineFilter(airline)}>
              {airline}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      
      <Button type="button" variant="ghost" onClick={onReset} className={`${buttonStyle} text-red-400 hover:bg-red-500/10 hover:text-red-300`}>
        <X className="w-3 h-3" />
        <span>Reset</span>
      </Button>
    </div>
  );
}